import React, {PropTypes} from 'react'
import {Modal} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {Form} from 'react-form'
import './AdBox.css'
import AdBoxForm from './AdBoxForm'
import showToastr from '../../../../utils/showToastr'
import ErrorHandler from '../../../../utils/ErrorHandler'
import validateAdBox from '../../../../utils/validateAdBox'

class AdBox extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      message: { status: '', context: '' },
      isLoading: false,
      ad: {
        horse_id: props.horse.id,
        price: '',
        description: '',
        type: 'sale',
        phone: props.user.mobile ? props.user.mobile : props.user.phone ? props.user.phone : ''
      },
      adPrices: {
        sale: '',
        belly_rental: '',
        mate: ''
      }
    }
    this.saveAd = this.saveAd.bind(this)
  }

  componentDidMount () {
    Actions.horseshoeTariff().then((res) => {
      let priceList = { sale: '', belly_rental: '', mate: '' }
      res.data.map(item => {
        priceList.sale = item.type === 'ad-sale' ? item.count : priceList.sale
        priceList.mate = item.type === 'ad-mate' ? item.count : priceList.mate
        priceList.belly_rental = item.type === 'ad-belly-rental' ? item.count : priceList.belly_rental
        return undefined
      })
      this.setState({adPrices: priceList})
    })
  }

  saveAd (values) {
    this.setState({isLoading: true})
    Actions.saveAd({...values, price: values.price === 'توافقی' ? 0 : values.price.replace(/,/gi, '')}).then((res) => {
      this.props.toggler(false)
      showToastr('success', 'ثبت آگهی', res.data.messages[0])
      Actions.userInfo()
      this.setState({isLoading: false})
      typeof (this.props.afterSave) === 'function' && this.props.afterSave()
    }).catch((err) => {
      let eh = new ErrorHandler(err)
      this.setState({message: eh.message, isLoading: false})
      eh.setFormErrors(this.refs.adForm)
      eh.showToastrIn('ثبت آگهی')
    })
  }

  render () {
    const {toggler, isVisible, horse, user} = this.props
    const {ad, adPrices, message, isLoading} = this.state
    const hider = () => {
      toggler(false)
    }
    return (
      <Modal show={isVisible} onHide={hider} bsSize="sm" aria-labelledby="contained-modal-title-sm">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-sm">ثبت آگهی</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>ثبت آگهی با کسر از نعل‌های پروفایل انجام می‌شود</p>
          {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
          <Form
            ref="adForm"
            values={ad}
            validate={validateAdBox}
            horse={horse}
            prices={adPrices}
            user={user}
            disable={isLoading}
            toggler={toggler}
            onSubmit={(values) => this.saveAd(values)}
          >
            {AdBoxForm}
          </Form>
        </Modal.Body>
      </Modal>
    )
  }
}

AdBox.propTypes = {
  toggler: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  horse: PropTypes.object.isRequired,
  user: PropTypes.object,
  afterSave: PropTypes.func
}

export default AdBox



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseBreederOwner/AdBox/AdBox.js